<template>
  <div class="filters-component">
    <div class="content">
      <div class="title">{{ $t('filter') }}:</div>
      <div class="filters-wrap">
        <div class="fields-wrap">
          <div class="field date">
            <date-component
              v-model="filter.flightDateFrom"
              :placeholder="$t('choose-date-from')"
              name="fly-date-from"
            />
          </div>
          <div class="field date">
            <date-component
              v-model="filter.flightDateTo"
              :placeholder="$t('choose-date-to')"
              name="fly-date-to"
            />
          </div>
          <div class="field">
            <text-component
              v-model="filter.flightNumber"
              :placeholder="$t('flight-number')"
              name="nr-lotu"
              type="text"
            />
          </div>
          <div v-if="isFlightNumberInvalid" class="error">
            {{ $t('filters-invalid-search') }}
          </div>
        </div>
        <button-component class="btn--filter" gray @click="filterDashboard">
          {{ $t('filter-button') }}
        </button-component>
      </div>
    </div>
  </div>
</template>

<script>
import TextComponent from '@/components/form/fields/Text'
import ButtonComponent from '@/components/Button'
import DateComponent from '@/components/form/fields/Date'
import { format } from 'date-fns'

export default {
  components: {
    TextComponent,
    ButtonComponent,
    DateComponent
  },
  props: {
    initialFilters: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      filter: {
        flightDateFrom: '',
        flightDateTo: '',
        flightNumber: ''
      },
      isFlightNumberInvalid: false
    }
  },
  created() {
    this.filter = this.initialFilters
  },
  methods: {
    filterDashboard() {
      const { flightDateFrom, flightDateTo, flightNumber } = this.filter
      const parsedFlightDateFrom = flightDateFrom
        ? format(new Date(flightDateFrom), 'yyyy-MM-dd')
        : null

      const parsedFlightDateTo = flightDateTo
        ? format(new Date(flightDateTo), 'yyyy-MM-dd')
        : null

      const normalizedFlightNumber = flightNumber
        .replace(/\s+/g, '')
        .toUpperCase()

      const parsedFlightNumber = `${normalizedFlightNumber.substring(
        0,
        2
      )} ${normalizedFlightNumber.substring(2)}`

      this.isFlightNumberInvalid =
        normalizedFlightNumber && normalizedFlightNumber.length < 5

      if (this.isFlightNumberInvalid) return

      const filter = {
        flightDateFrom: parsedFlightDateFrom,
        flightDateTo: parsedFlightDateTo,
        flightNumber: parsedFlightNumber
      }
      this.$emit('click', filter)
    }
  }
}
</script>

<style lang="scss" scoped>
.filters-component {
  background: $gray-darker;
  padding: 20px 39px 28px;
  margin: -10px -15px 0;

  @include media-down(md) {
    padding: 20px 15px 20px;
  }
}

.content {
  margin: 0 auto;
  max-width: calc(510px + 44px * 2);
  @include media-up(md) {
    max-width: $max-width;
  }
}

.title {
  margin-bottom: 14px;
  font-size: 12px;
  font-weight: 500;
  text-transform: uppercase;
  text-align: left;
}

.filters-wrap {
  display: flex;
  align-items: flex-start;

  @include media-down(md) {
    flex-wrap: wrap;
  }
}

.fields-wrap {
  display: grid;
  grid-gap: 10px;

  @include media-down(md) {
    width: 100%;
    grid-gap: 16px;
  }
}

.field {
  @include media-up(md) {
    grid-row: 1;
  }

  @media (max-width: 564px) {
    width: 100%;
  }

  /deep/ input {
    @include media-up(md) {
      width: 120px;
    }
  }
}

.date {
  /deep/ input {
    @include media-down(md) {
      width: 100%;
    }

    @include media-up(md) {
      width: 185px;
    }
  }
}

.btn--filter {
  height: 46px;
  padding-top: 11px;
  padding-bottom: 11px;
  background: transparent;
  border: 1px solid $navy;
  border-radius: 40px;
  font-size: 10px;
  font-weight: 500;
  color: $navy;
  margin-left: 10px;

  &:hover {
    color: #fff;
    background: $navy;
  }

  @include media-down(md) {
    margin-top: 16px;
    margin-left: 0;
  }
}

.error {
  color: $error;
  font-size: 75%;
  padding: 8px;
  background: rgba($error, 0.1);
  border-radius: 4px;

  @include media-up(md) {
    grid-column: 1 / 4;
  }
}
</style>
